import { Button } from '@op/opds.opux';
import React, { type FC, type ReactNode } from 'react';
import i18n from './../../../i18n';
import layoutStyles from './../../components/common/Layout.module.scss';
import PageHeading from './../../components/PageHeading/PageHeading';
import { ActionButtonRow } from '../../components/ActionButtonRow';
import { PriceSummary } from '../../components/PriceSummary';
import InfoSection from 'individual/components/InfoSection';
import PurchasePageIngress from 'individual/components/PurchasePageIngress';
import { useAppStore } from 'state/store';

interface Props {
  children: ReactNode;
}

const InitialPurchaseView: FC<Props> = ({ children }) => {
  const handleUnauthenticatedSubmit = useAppStore(
    (state) => state.handleUnauthenticatedSubmit
  );

  return (
    <>
      <PageHeading
        data-cy='calculator-title'
        data-testid='initial-purchase-view-heading'
        title={i18n.t('initialPurchase.header')}
      />
      <PurchasePageIngress />
      {children}
      <PriceSummary />
      <div className={layoutStyles.columnReverse}>
        <InfoSection />
        <ActionButtonRow
          primaryButton={
            <Button
              primary
              onClick={handleUnauthenticatedSubmit}
              data-testid='continue-to-purchase-button'>
              {i18n.t('initialPurchase.continueToPurchaseButton')}
            </Button>
          }
          infoText={i18n.t('initialPurchase.continueToPurchase')}
        />
      </div>
    </>
  );
};

export default InitialPurchaseView;
